// extracted by mini-css-extract-plugin
export var footer = "_nn-5";
export var fulfillmentInput = "_nn-0";
export var shipDateInput = "_nn-1";
export var shipmentModal = "_nn-2";
export var shipmentModalContent = "_nn-3";
export var tableContainer = "_nn-4";